import styled from '@mui/material/styles/styled'
import Button from '@mui/material/Button'

/*** Primary Buttons ***/

export const PrimaryLightButton = styled(Button)(({ theme }) => `
    background-color: ${theme.palette.primary.light};
    color: #FFFFFF;
    text-transform: capitalize;
    font-family: Roboto-Medium;
    :hover{
        background-color: ${theme.palette.primary.dark};
    }
`)

export const PrimaryButton = styled(Button)(({ theme }) => `
    background-color: ${theme.palette.primary.main};
    color: #FFFFFF;
    text-transform: capitalize;
    font-family: Roboto-Medium;
    :hover{
        background-color: ${theme.palette.primary.dark};
    }
`)

export const PrimaryDarkButton = styled(Button)(({ theme }) => `
    background-color: ${theme.palette.primary.dark};
    color: #FFFFFF;
    text-transform: capitalize;
    font-family: Roboto-Medium;
    :hover{
        background-color: ${theme.palette.primary.main};
    }
`)

export const PrimaryOutlinedButton = styled(Button)(({ theme }) => `
    border: 1px solid ${theme.palette.primary.main};
    color: theme.palette.primary.main;
    text-transform: capitalize;
    fontFamily: Roboto-Medium;
    :hover{
        background-color: ${theme.palette.primary.main};
        color: #FFF
    }
`)

export const PrimaryTextButton = styled(Button)(({ theme }) => `
    color: ${theme.palette.primary.main};
    font-family: 'Roboto-Medium';
    text-transform: capitalize;
    :hover{
        text-decoration: underline
    }
`)



/*** Secondary Buttons ***/

export const SecondaryLightButton = styled(Button)(({ theme }) => `
    background-color: ${theme.palette.secondary.light};
    color: #FFFFFF;
    text-transform: capitalize;
    font-family: Roboto-Medium;
    :hover{
        background-color: ${theme.palette.secondary.main};
    }
`)

export const SecondaryButton = styled(Button)(({ theme }) => `
    background-color: ${theme.palette.secondary.main};
    color: #FFFFFF;
    text-transform: capitalize;
    font-family: Roboto-Medium;
    :hover{
        background-color: ${theme.palette.secondary.light};
    }
`)

export const SecondaryOutlinedButton = styled(Button)(({ theme }) => `
    border: 1px solid ${theme.palette.secondary.main};
    color: ${theme.palette.secondary.main};
    text-transform: capitalize;
    font-family: Roboto-Medium;
`)

export const SecondaryTextButton = styled(Button)(({ theme }) => `
    color: ${theme.palette.secondary.main};
    text-transform: capitalize;
    font-family: 'Roboto-Medium';
    :hover{
        text-decoration: underline
    }
`)